export default __webpack_public_path__ + "static/media/redpay.8eb9f145.png";